class CustomSlideshowElement extends HTMLElement {
  constructor() {
    super();
    this.swiperInstances = new Map();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.init();
    this.initShopifyEditor();
  }

  disconnectedCallback() {
    // Limpiar instancias de Swiper al desconectar el elemento
    this.swiperInstances.forEach(swiper => {
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
    });
    this.swiperInstances.clear();
  }

  init() {
    const slideshows = document.querySelectorAll('.custom-slideshow');
    slideshows.forEach((slideshow, index) => {
      this.initSlideshow(slideshow, index);
    });
  }

  initSlideshow(slideshow, index) {
    const autoplay = slideshow.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(slideshow.dataset.autoplaySpeed) || 5000;
    const showDots = slideshow.dataset.showDots === 'true';
    const showNavigation = slideshow.dataset.showNavigation === 'true';

    console.log('Slideshow config:', { autoplay, autoplaySpeed, showDots, showNavigation });

    const swiperContainer = slideshow.querySelector('.custom-slideshow__swiper');
    if (!swiperContainer) {
      console.warn('No se encontró el contenedor de Swiper');
      return;
    }

    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      autoplay: autoplay ? {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,

      navigation: showNavigation ? {
        nextEl: slideshow.querySelector('.swiper-button-next'),
        prevEl: slideshow.querySelector('.swiper-button-prev'),
      } : false,

      pagination: showDots ? {
        el: slideshow.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true
      } : false,

      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    });

    // Guardar la instancia de Swiper
    this.swiperInstances.set(index, swiper);

    if (autoplay) {
      slideshow.addEventListener('mouseenter', () => {
        if (swiper.autoplay && swiper.autoplay.stop) {
          swiper.autoplay.stop();
        }
      });

      slideshow.addEventListener('mouseleave', () => {
        if (swiper.autoplay && swiper.autoplay.start) {
          swiper.autoplay.start();
        }
      });
    }
  }

  initShopifyEditor() {
    // Detectar si estamos en el editor de Shopify
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      // Escuchar cambios en el editor
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target;
        if (section.classList.contains('custom-slideshow')) {
          this.handleSectionLoad(section);
        }
      });

      // Escuchar cambios en la configuración
      document.addEventListener('shopify:section:reorder', (event) => {
        this.reinitializeSlideshows();
      });

      // Escuchar cambios en bloques
      document.addEventListener('shopify:block:select', (event) => {
        this.handleBlockSelect(event);
        this.reinitializeSlideshows();
      });

      document.addEventListener('shopify:block:deselect', (event) => {
        this.handleBlockDeselect(event);
        this.reinitializeSlideshows();
      });

      // Escuchar cambios en la configuración de secciones
      document.addEventListener('shopify:section:select', (event) => {
        this.handleSectionSelect(event);
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        this.handleSectionDeselect(event);
      });
    }
  }

  handleSectionLoad(section) {
    // Destruir instancia anterior si existe
    const slideshowIndex = Array.from(document.querySelectorAll('.custom-slideshow')).indexOf(section);
    if (this.swiperInstances.has(slideshowIndex)) {
      const swiper = this.swiperInstances.get(slideshowIndex);
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
      this.swiperInstances.delete(slideshowIndex);
    }

    // Reinicializar el slideshow
    setTimeout(() => {
      this.initSlideshow(section, slideshowIndex);
    }, 100);
  }

  reinitializeSlideshows() {
    // Destruir todas las instancias
    this.swiperInstances.forEach(swiper => {
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
    });
    this.swiperInstances.clear();

    // Reinicializar todos los slideshows
    setTimeout(() => {
      this.init();
    }, 200);
  }

  handleBlockSelect(event) {
    const block = event.target;
    const slideshow = block.closest('.custom-slideshow');
    if (slideshow) {
      const slideshowIndex = Array.from(document.querySelectorAll('.custom-slideshow')).indexOf(slideshow);
      const swiper = this.swiperInstances.get(slideshowIndex);
      if (swiper && typeof swiper.slideTo === 'function') {
        // Resaltar el slide seleccionado
        const slideIndex = Array.from(slideshow.querySelectorAll('.swiper-slide')).indexOf(block);
        if (slideIndex >= 0) {
          swiper.slideTo(slideIndex);
        }
      }
    }
  }

  handleBlockDeselect(event) {
    // Opcional: restaurar estado normal
  }

  handleSectionSelect(event) {
    const section = event.target;
    if (section.classList.contains('custom-slideshow')) {
      // Opcional: agregar lógica cuando se selecciona la sección
      console.log('Sección de slideshow seleccionada');
    }
  }

  handleSectionDeselect(event) {
    const section = event.target;
    if (section.classList.contains('custom-slideshow')) {
      // Opcional: agregar lógica cuando se deselecciona la sección
      console.log('Sección de slideshow deseleccionada');
    }
  }

  // Método público para actualizar configuración
  updateConfig(newConfig) {
    if (newConfig && typeof newConfig === 'object') {
      this.reinitializeSlideshows();
    }
  }

  // Método público para obtener estadísticas
  getStats() {
    return {
      totalSlideshows: this.swiperInstances.size,
      activeInstances: Array.from(this.swiperInstances.values()).filter(swiper => swiper && !swiper.destroyed).length
    };
  }
}

// Registrar el Custom Element
if (!customElements.get('custom-slideshow')) {
  customElements.define('custom-slideshow', CustomSlideshowElement);
}

// Inicialización automática cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  // Crear instancia del Custom Element
  const slideshowElement = document.createElement('custom-slideshow');
  document.body.appendChild(slideshowElement);
});

// También inicializar si el DOM ya está cargado
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const slideshowElement = document.createElement('custom-slideshow');
    document.body.appendChild(slideshowElement);
  });
} else {
  const slideshowElement = document.createElement('custom-slideshow');
  document.body.appendChild(slideshowElement);
} 